import React, { useState, useRef } from 'react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { Paper, Button, ButtonGroup, ClickAwayListener, withStyles, Grow, Popper, MenuList, MenuItem } from '@material-ui/core';

const styles = theme => ({
    root: {
        marginLeft: '3%',
        height: '45%',
        borderRadius: '1px',
    },
    buttonDisplay: {
        borderRadius: '1px',
    },
    popper: {

        zIndex: 11
    }
});
function ButtonGroupComponent(props) {
    const [open, setOpen] = useState(false);
    const { options, disabled, onClick, classes } = props;
    const anchorRef = useRef(null);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleClick = () => {
        onClick(`${options[selectedIndex].value}`);
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    return (
        <>
            <ButtonGroup className={classes.root} size='small' variant="contained" color="primary" ref={anchorRef} aria-label="split button">
                <Button size="small" className={classes.buttonDisplay} onClick={handleClick}>{options[selectedIndex].label}</Button>
                <Button
                    color="primary"
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                >
                    <ArrowDropDownIcon />
                </Button>
            </ButtonGroup>
            <Popper className={classes.popper} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: 'right bottom',
                        }}
                    >
                        <Paper >
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="split-button-menu">
                                    {options.map((option, index) => (
                                        <MenuItem
                                            key={option.value}
                                            disabled={disabled}
                                            selected={index === selectedIndex}
                                            onClick={(event) => handleMenuItemClick(event, index)}
                                        >
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
}
export default (withStyles(styles, { withTheme: true })(ButtonGroupComponent));